var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { groupBy, keyBy, map, mapValues } from 'lodash';
import { EntityDataGrid } from '../entities/entity-data-grid';
var cls = classNames('form-field-number');
export var FormFieldLinkedJunctionDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var GridStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isChromeless = _a.isChromeless;
    return isChromeless && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    "], ["\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Grid: styled(EntityDataGrid)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), GridStyles)
};
export var FormFieldLinkedJunction = function (props) {
  var className = props.className,
    value = props.value,
    data = props.data,
    entityTypeDefinition = props.entityTypeDefinition,
    isChromeless = props.isChromeless,
    supportingEntityTypeDefinitions = props.supportingEntityTypeDefinitions;
  // console.log("ENTITY TYPE DEFN", entityTypeDefinition);
  // console.log("SUPPORTING ENTITY TYPE DEFNS", supportingEntityTypeDefinitions);
  // console.log("DATA", data);
  var itemsByEntityTypeName = groupBy(data, function (entity) {
    return entityTypeNameFor(entity);
  });
  if (!data.length && supportingEntityTypeDefinitions) {
    /* @ts-ignore */
    itemsByEntityTypeName = mapValues(keyBy(supportingEntityTypeDefinitions, 'name'), function (defn) {
      return [];
    });
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, map(itemsByEntityTypeName, function (items, entityTypeName) {
    var supportingEntityTypeDefinition = supportingEntityTypeDefinitions[entityTypeName];
    if (supportingEntityTypeDefinition) {
      return React.createElement(My.Grid, {
        isChromeless: isChromeless,
        showBorder: !isChromeless,
        key: entityTypeName,
        items: items,
        defn: supportingEntityTypeDefinition
      });
    }
    return null;
  }));
};
FormFieldLinkedJunction.cls = cls;
FormFieldLinkedJunction.defaultProps = FormFieldLinkedJunctionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;